import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';

// Layout
import { Layout } from './components/Layout';
import ContactFAB from './components/ContactFAB';

// Public Pages
import Home from './pages/Home';
import PreInscription from './pages/PreInscription';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import About from './pages/About';
import Contact from './pages/Contact';

// Center Pages
import Diplomante from './pages/centers/Diplomante';
import Qualifiante from './pages/centers/Qualifiante';
import Certifiante from './pages/centers/Certifiante';
import Linguistique from './pages/centers/Linguistique';

// Admin Pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminPreregistrations from './pages/admin/AdminPreregistrations';
import AdminBlog from './pages/admin/AdminBlog';
import AdminMedia from './pages/admin/AdminMedia';
import AdminMessages from './pages/admin/AdminMessages';
import AdminCallbacks from './pages/admin/AdminCallbacks';
import AdminUsers from './pages/admin/AdminUsers';
import AdminContent from './pages/admin/AdminContent';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/preinscription" element={<Layout><PreInscription /></Layout>} />
            <Route path="/blog" element={<Layout><Blog /></Layout>} />
            <Route path="/blog/:slug" element={<Layout><BlogPost /></Layout>} />
            <Route path="/a-propos" element={<Layout><About /></Layout>} />
            <Route path="/contact" element={<Layout><Contact /></Layout>} />
            
            {/* Center Routes */}
            <Route path="/diplomante" element={<Layout><Diplomante /></Layout>} />
            <Route path="/qualifiante" element={<Layout><Qualifiante /></Layout>} />
            <Route path="/certifiante" element={<Layout><Certifiante /></Layout>} />
            <Route path="/linguistique" element={<Layout><Linguistique /></Layout>} />
            
            {/* Admin Routes */}
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/preregistrations" element={<AdminPreregistrations />} />
            <Route path="/admin/blog" element={<AdminBlog />} />
            <Route path="/admin/media" element={<AdminMedia />} />
            <Route path="/admin/messages" element={<AdminMessages />} />
            <Route path="/admin/callbacks" element={<AdminCallbacks />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/content" element={<AdminContent />} />
          </Routes>
          <ContactFAB />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </HelmetProvider>
  );
}

export default App;
